module.exports = __webpack_public_path__ + "static/media/multi_select_icon.cedf78ae.svg";